import { Select } from '@components/ui';
import { Controller } from 'react-hook-form';
import useRole from 'src/hooks/useRole';
import { validityTypesV2, validityTypesV2Dealer } from 'src/modules/labels';
import UserRole from 'src/types/UserRoles';

import { muiInputLabelProps } from './constants';

type ValiditySelectProps = {
  control: any;
};

const ValiditySelectNew = ({ control }: ValiditySelectProps) => {
  const { hasRole } = useRole();
  return (
    <Controller
      name="validity"
      control={control}
      render={({ field: { ref: _ref, ...field } }) => (
        <Select
          label="carsTableNext.filter.validity"
          {...field}
          options={hasRole(UserRole.ADMIN) ? validityTypesV2 : validityTypesV2Dealer}
          InputLabelProps={muiInputLabelProps}
          clearable
        />
      )}
    />
  );
};

export default ValiditySelectNew;
